import React from 'react';
import { modules } from '../data/landing';
export function ModulesSection() {
  return <section className="bg-white px-5 py-20" data-id="element-111" data-mp="1nuxtv0c8ezz0">
      <div className="mx-auto max-w-6xl" data-id="element-112" data-mp="1nt3dlzbwnw19">
        <div className="mx-auto max-w-3xl text-center" data-id="element-113" data-mp="1ivbkj1ziy3vh">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-gold-dark" data-id="element-114" data-mp="1iw375nb58r9m">
            The complete playbook
          </p>
          <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-ink sm:text-5xl" data-id="element-115" data-mp="2bk8os16wi058">
            Inside the box set — six complete volumes
          </h2>
        </div>
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-116" data-mp="26jbaw0sxbs9j">
          {modules.map(({
          icon: Icon,
          kicker,
          title,
          description,
          features,
          accentClass
        }) => <article key={kicker} className="flex min-h-[250px] flex-col border border-night-line p-6" data-id="element-117" data-mp="1wp2jjgfmq5cy">
                <div className="flex items-center gap-3" data-id="element-118" data-mp="l7jinupiuehk">
                  <span className={`grid h-11 w-11 place-items-center ${accentClass}`} data-id="element-119" data-mp="la5qzwk8ky0u">
                    <Icon className="h-5 w-5 text-white" data-id="element-120" data-mp="1nuv4o8mzhddt" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-widest text-gold-dark" data-id="element-121" data-mp="18xb55h8uwaf1">
                    {kicker}
                  </p>
                </div>
                <h3 className="mt-5 text-xl font-bold leading-tight text-night" data-id="element-122" data-mp="1dub1h0fwlysy">
                  {title}
                </h3>
                <p className="mt-3 text-sm font-medium leading-relaxed text-night-slate" data-id="element-123" data-mp="14vh7zixvdojm">
                  {description}
                </p>
                <p className="mt-auto pt-5 text-xs font-bold leading-relaxed text-night" data-id="element-124" data-mp="q7mgg5vllq84">
                  {features}
                </p>
              </article>)}
        </div>
      </div>
    </section>;
}